import { render, staticRenderFns } from "./Overlays.vue?vue&type=template&id=4b441228&scoped=true&"
import script from "./Overlays.vue?vue&type=script&lang=js&"
export * from "./Overlays.vue?vue&type=script&lang=js&"
import style0 from "./Overlays.vue?vue&type=style&index=0&id=4b441228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b441228",
  null
  
)

export default component.exports